import { RootState } from '../types'
import { AppLanguage } from './types'

export const selectAppLanguage = (state: RootState): AppLanguage => state.app.language
